// AI-CONTEXT: See docs/patterns.md#hook-permission-gate

import permissionsCatalog from './permissionsCatalog'

/**
 * Het label van een recht, woord voor woord zoals het in Instellingen → Rollen
 * staat.
 *
 * Bewust het `label` en niet de `category`: die is grover ('Ondersteuning' dekt
 * deelnemers, huishoudens, adressen én formulieren) en stuurt de lezer dus naar
 * een vakje dat vier rechten bevat. Het label is precies het vinkje dat de
 * beheerder moet aanzetten, dus het is overschrijfbaar in een verzoek aan hem.
 *
 * @param {string} [key] - Sleutel uit permissionsCatalog, bijv. 'strategy.edit'
 * @returns {string} Het label, of '' als de sleutel niet in de catalogus staat
 */
const permissionLabel = (key) => {
    if (!key) return ''
    const entry = permissionsCatalog.find((permission) => permission.key === key)
    return entry?.label || ''
}

export default permissionLabel
